import React from 'react';
import styles from './BtnTiertary.module.scss'

const BtnTiertary = ({children, onClick, disabled, style}) => {
    const defaultStyle = {
        cursor: "pointer"
    };

    const handleClick = (e) => {
        if (!disabled && onClick) {
            onClick(e);
        }
    };

    return (
        <div className={`${styles.btnTiertary} ${disabled ? styles.disabled : ''}`} style={{...defaultStyle, ...style}} onClick={handleClick}>
            <span>{children}</span>
        </div>
    );
};

export default BtnTiertary;
